import { CellDataTypes } from '@cluster/web-components'
import { AppThunk, ApiError } from "../misc"
import { selectCellLayoutIds } from "../selectors"
import { doLogoutUser } from "./user"

export enum CELL_ACTIONS {
  FETCH_CELLS_START = "FETCH_CELLS_START",
  FETCH_CELLS_SUCCESS = "FETCH_CELLS_SUCCESS",
  FETCH_CELLS_ERROR = "FETCH_CELLS_ERROR",
  FETCH_CELL_DETAIL_START = "FETCH_CELL_DETAIL_START",
  FETCH_CELL_DETAIL_SUCCESS = "FETCH_CELL_DETAIL_SUCCESS",
  FETCH_CELL_DETAIL_ERROR = "FETCH_CELL_DETAIL_ERROR",
  CELLS_UPDATED = "CELLS_UPDATED",
}

export type CELL_ACTION_TYPES = FetchCellsAction | FetchCellDetailAction | UpdateCellAction

export type FetchCellsAction = {
  type: CELL_ACTIONS.FETCH_CELLS_START | CELL_ACTIONS.FETCH_CELLS_SUCCESS | CELL_ACTIONS.FETCH_CELLS_ERROR,
  payload?: {
    data: CellDataTypes.CellType[];
    pagination?: object;
  },
  error: ApiError
}

export type FetchCellDetailAction = {
  type: CELL_ACTIONS.FETCH_CELL_DETAIL_START | CELL_ACTIONS.FETCH_CELL_DETAIL_SUCCESS | CELL_ACTIONS.FETCH_CELL_DETAIL_ERROR,
  payload?: CellDataTypes.CellType,
  error: ApiError
}

export type UpdateCellAction = {
  type: CELL_ACTIONS.CELLS_UPDATED,
  payload?: CellDataTypes.CellType[],
}

export const doGetCells = (cellIds: number[]): AppThunk => async (dispatch, getState, api) => {
  dispatch({type: CELL_ACTIONS.FETCH_CELLS_START});
  try {
    let data = await api.getMultipleCells({
      ids: cellIds.join(","),
      pageSize: 100,
      withTags: true
    });

    dispatch({
      type: CELL_ACTIONS.FETCH_CELLS_SUCCESS,
      payload: data
    });

    return data.data;
  } catch (message) {
    try {
      const error = JSON.parse(message.message);

      dispatch({
        type: CELL_ACTIONS.FETCH_CELLS_ERROR,
        error
      });

      if (error.errorCode === "AUTH_INVALID_TOKEN" || error.errorCode === "AUTH_HEADER_MISSING" || error.errorCode === "AUTH_EXPIRED_TOKEN" || error.errorCode === "AUTH_PASSWORD_CHANGED") {
        dispatch(doLogoutUser("Your session has expired."));
      }
    } catch(badError) {
      dispatch({
        type: CELL_ACTIONS.FETCH_CELLS_ERROR,
        error: {
          developerMessage: message.message,
          userMessage: "An unknown error occured"
        }
      });
    }
  }
}

export const doGetCellDetail = (cellId: number): AppThunk => async (dispatch, getState, api) => {
  dispatch({type: CELL_ACTIONS.FETCH_CELL_DETAIL_START});
  try {
    let data = await api.getCell(cellId);

    dispatch({
      type: CELL_ACTIONS.FETCH_CELL_DETAIL_SUCCESS,
      payload: data
    });

  } catch (message) {
    try {
      const error = JSON.parse(message.message);

      dispatch({
        type: CELL_ACTIONS.FETCH_CELL_DETAIL_ERROR,
        error
      });

      if (error.errorCode === "AUTH_INVALID_TOKEN" || error.errorCode === "AUTH_HEADER_MISSING" || error.errorCode === "AUTH_EXPIRED_TOKEN" || error.errorCode === "AUTH_PASSWORD_CHANGED") {
        dispatch(doLogoutUser("Your session has expired."));
      }
    } catch(badError) {
      dispatch({
        type: CELL_ACTIONS.FETCH_CELL_DETAIL_ERROR,
        error: {
          developerMessage: message.message,
          userMessage: "An unknown error occured"
        }
      });
    }
  }
}

export const doGetLayoutCells = (): AppThunk => (dispatch, getState) => {
  const state = getState();
  const cellIds = selectCellLayoutIds(state);

  return dispatch(doGetCells(cellIds));
}

export const doUpdateCells = (cells: CellDataTypes.CellType[]): UpdateCellAction => {
  return {
    type: CELL_ACTIONS.CELLS_UPDATED,
    payload: cells
  }
}
